import { FC } from "react";
import { IconProps } from "@/shared/types/icon";
import { Svg } from "@abel-technologies-as/components";

type DotsProps = { style?: React.CSSProperties } & IconProps;

export const Dots: FC<DotsProps> = (props) => {
	return (
		<Svg width="6" height="18" viewBox="0 0 6 18" fill="none" {...props}>
			<path
				d="M4.25 2.75C4.25 2.05964 3.69036 1.5 3 1.5C2.30964 1.5 1.75 2.05964 1.75 2.75C1.75 3.44036 2.30964 4 3 4C3.69036 4 4.25 3.44036 4.25 2.75Z"
				stroke={props.color ?? "#344054"}
				strokeWidth="1.66667"
			/>
			<path
				d="M4.25 9C4.25 8.30964 3.69036 7.75 3 7.75C2.30964 7.75 1.75 8.30964 1.75 9C1.75 9.69036 2.30964 10.25 3 10.25C3.69036 10.25 4.25 9.69036 4.25 9Z"
				stroke={props.color ?? "#344054"}
				strokeWidth="1.66667"
			/>
			<path
				d="M4.25 15.25C4.25 14.5596 3.69036 14 3 14C2.30964 14 1.75 14.5596 1.75 15.25C1.75 15.9404 2.30964 16.5 3 16.5C3.69036 16.5 4.25 15.9404 4.25 15.25Z"
				stroke={props.color ?? "#344054"}
				strokeWidth="1.66667"
			/>
		</Svg>
	);
};
